import { FC } from 'react';
import { Box, Tooltip } from "@mui/material";
import styles from './styles';

interface NameWithTooltipProps {
  title: string,
  name: string,
}

const NameWithTooltip: FC<NameWithTooltipProps> = (props) => {
  const { title, name } = props;
  
  if (name.length > 25) {
    return (
      <Tooltip title={title} placement='bottom-start'>
        <Box sx={styles.name}>
          {`${name.slice(0, 15)}...`}
        </Box>
      </Tooltip>
    );
  } else {
    return (
      <Box sx={styles.name}>
        {name}
      </Box>
    );
  }
}

export default NameWithTooltip;